import React from "react";
import "./invoices-view.css";
import "../../styles/list-glass.css";
import Alert from "../../components/glass/GlassAlert";
import { colors } from "../../theme";
import { Redirect, Link } from "react-router-dom";
import SpinnerView from "../../components/spinner/spinner-view";
import DateFilter from "../../components/DateFilter";
import DownloadLink from "react-download-link";
import urls from "../../network/urls";
import moment from "moment";
import Invoice from "../../components/invoice";
import { format } from "../../helpers/invoiceNumber";
import { documentFilename } from "../../helpers/documentName";

class HomeView extends React.Component {
  state = {
    modal: false,
    pdfModal: false,
    newInvoice: {},
    newLineItem: {},
    rankType: "all",
    showAdd: false,
    selected: [],
    search: "",
  };

  handleChange = (value, prop) => {
    var t = this.state.newInvoice;
    t[prop] = value;
    this.setState({
      newInvoice: t,
    });
  };

  handleLineChange = (value, prop) => {
    var t = this.state.newLineItem;
    t[prop] = value;
    this.setState({
      newLineItem: t,
    });
  };

  handleSearch = (value) => {
    console.log(value);
    this.setState({
      search: value,
    });
  };

  togglePDF = () => {
    this.setState({
      pdfModal: !this.state.pdfModal,
    });
  };

  toggle = () => {
    this.setState({
      modal: !this.state.modal,
      newInvoice: {},
    });
  };

  addLineItem = () => {
    this.setState({
      newInvoice: {
        ...this.state.newInvoice,
        descriptions: this.state.newInvoice.descriptions
          ? [
              ...this.state.newInvoice.descriptions,
              { ...this.state.newLineItem },
            ]
          : [{ ...this.state.newLineItem }],
      },
    });
  };

  deleteLineItem = (desc) => {
    this.setState({
      newInvoice: {
        ...this.state.newInvoice,
        descriptions: this.state.newInvoice.descriptions.filter(
          (item) => item.description != desc
        ),
      },
    });
  };

  edit = (invoice) => {
    this.setState({
      modal: !this.state.modal,
      newInvoice: invoice,
    });
  };

  handleClick = (event, name) => {
    const selectedIndex = this.state.selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(this.state.selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(this.state.selected.slice(1));
    } else if (selectedIndex === this.state.selected.length - 1) {
      newSelected = newSelected.concat(this.state.selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        this.state.selected.slice(0, selectedIndex),
        this.state.selected.slice(selectedIndex + 1)
      );
    }

    this.setState({
      selected: newSelected,
    });
  };

  handleSelectAll = (onlyUnSent) => {
    let newSelected = this.props.invoices.invoices
      .filter((i) => !i.isQuote && !i.paid && (onlyUnSent ? !i.sent : true))
      .map((i) => i._id);

    this.setState({
      selected: newSelected,
    });
  };

  componentDidMount() {
    // Only fetch once a company is selected. On a hard refresh the company
    // may not have rehydrated yet — componentDidUpdate picks it up below.
    if (this.props.selectedCompanyId) {
      this.props.dispatchGetInvoices();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // Fetch invoices when the selected company first becomes available
    // (or changes) — fixes the spinner hanging forever on a hard refresh.
    if (
      this.props.selectedCompanyId &&
      this.props.selectedCompanyId !== prevProps.selectedCompanyId
    ) {
      this.props.dispatchGetInvoices();
    }

    // Add/remove body class for scrolling when invoice view is shown
    if (this.state.showAdd !== prevState.showAdd) {
      if (this.state.showAdd) {
        document.body.classList.add("invoice-view-active");
      } else {
        document.body.classList.remove("invoice-view-active");
      }
    }
  }

  componentWillUnmount() {
    // Clean up body class when component unmounts
    document.body.classList.remove("invoice-view-active");
  }

  createInvoice = () => {
    this.props.createInvoice(this.state.newInvoice);
    this.setState({
      modal: !this.state.modal,
      newInvoice: "",
    });
  };

  setRank = (rank) => {
    this.setState({
      rankType: rank,
    });
  };

  scrollToTop = () => window.scrollTo(0, 0);

  getDataFromURL = (url, user, process) =>
    new Promise((resolve, reject) => {
      setTimeout(() => {
        let req = {
          headers: {
            username: user.username,
            token: user.token,
            AUTHORIZATION: user.token,
          },
          method: "GET",
        };

        fetch(url, req)
          .then((response) => response.blob())
          .then((data) => {
            resolve(data);
            if (process) this.props.dispatchGetInvoices();
          });
      });
    }, 2000);

  updateshowAdd = (showAdd) => {
    this.setState({ showAdd });
  };

  render() {
    if (this.props.user && !this.props.user._id) {
      return <Redirect to="/" />;
    }

    let all = 0;
    let paid = 0;
    let un = 0;
    let quote = 0;
    let credit = 0;
    let unTotal = 0;
    let paidTotal = 0;
    let quoteTotal = 0;
    let creditTotal = 0;

    var Invoices = [];

    let methodPaids = {};
    const isSelected = (name) => this.state.selected.indexOf(name) !== -1;

    if (this.props.invoices.invoices.length > 0) {
      Invoices = this.props.invoices.invoices.map((p, index) => {
        if (!methodPaids[p.methodPaid]) methodPaids[p.methodPaid] = 0;

        let total = 0;
        let preTotal = 0;
        let discount = 0;

        if (p.descriptions) {
          p.descriptions.map((i) => {
            let qty = i.qty ?? 1;
            preTotal += parseFloat(i.price) * parseFloat(qty);
          });

          if (p.discount && p.discount.hasDiscount) {
            if (p.discount.discountType == "Amount")
              discount = -1 * parseFloat(p.discount.discountValue);
            else
              discount =
                -1 * ((preTotal / 100) * parseFloat(p.discount.discountValue));
          }
          total = preTotal + discount;
          methodPaids[p.methodPaid] += total;

          all += 1;
          if (!!p.isCreditNote) {
            // A credit note is not outstanding and not paid — it reduces what
            // is owed, so it only nets off the outstanding total.
            credit += 1;
            creditTotal += total;
            unTotal -= total;
          } else if (!!p.isQuote) {
            quote += 1;
            quoteTotal += total;
          } else {
            if (!!!p.paid) {
              un += 1;
              unTotal += total;
            }
            if (!!p.paid) {
              paid += 1;
              paidTotal += total;
            }
          }
        }
        const isItemSelected = isSelected(p._id);
        const labelId = `enhanced-table-checkbox-${index}`;

        let diff = !p.paid ? (
          moment().diff(moment(p.dueDate), "days") > 0 ? (
            <span className="right badge badge-danger">
              {moment().diff(moment(p.dueDate), "days")}
              {" days overdue"}
            </span>
          ) : (
            <span className="right badge badge-warning">
              {moment().diff(moment(p.dueDate), "days")}
              {" days left"}
            </span>
          )
        ) : (
          ""
        );

        if (!!p.queuedForSending && !p.queuedForSendingError) {
          diff = (
            <>
              <span className="right badge badge-warning">{"Sending..."}</span>
              {diff}
            </>
          );
        }
        if (!!p.queuedForSendingError) {
          diff = (
            <>
              <span className="right badge badge-danger">
                {p.queuedForSendingError}
              </span>
              {diff}
            </>
          );
        }

        let sent = (
          <>
            {p.sent ? moment(p.sent).format("YYYY-MM-DD") : ""}
            {p.emails ? (
              <span className="right badge badge-info ml-1">
                {p.emails.length}
                {" times"}
              </span>
            ) : (
              ""
            )}
          </>
        );

        return {
          id: p._id,
          name: p.client
            ? (p.client.name + " " + (p.client.surname ? p.client.surname : "")).trim()
            : p.to,
          email:
            (p.client && (p.client.email || p.client.emailAddress)) ||
            p.emailTo ||
            "",
          invoiceDate: moment(p.invoiceDate).format("DD MMM YYYY"),
          dateRaw: p.invoiceDate,
          dueDate: !!p.dueDate ? moment(p.dueDate).format("DD MMM YYYY") : "",
          dueRaw: p.dueDate,
          // A credit note carries its own CRN number and reduces the balance,
          // so it shows its number and a negative amount in the list.
          iNumber: p.isCreditNote ? (p.creditNoteNumber || p.invoiceNumber) : p.invoiceNumber,
          paid: p.paid,
          sentDate: p.sent ? moment(p.sent).format("DD MMM YYYY") : "",
          queued: !!p.queuedForSending,
          queuedError: p.queuedForSendingError,
          total: (p.isCreditNote ? "-R " : "R ") + format(total),
          totalA: p.isCreditNote ? -total : total,
          isQuote: p.isQuote,
          isCreditNote: !!p.isCreditNote,
          creditOfNumber: p.creditOfNumber,
          method: p.methodPaid,
        };
      });
    }

    // ---- Filter + sort the row items, then group by status ----
    const filtered = Invoices.filter((i) => {
      // Credit notes are never "paid", "unpaid" or a quote — they only appear
      // under All and under their own filter.
      if (this.state.rankType == "all") return true;
      else if (this.state.rankType == "credit") return !!i.isCreditNote;
      else if (this.state.rankType == "paid") return !!i.paid && !i.isQuote && !i.isCreditNote;
      else if (this.state.rankType == "quote") return !!i.isQuote;
      else if (this.state.rankType == "unpaid") return !!!i.paid && !i.isQuote && !i.isCreditNote;
      return true;
    })
      .filter((i) => {
        if (this.state.search == "") return true;
        return (
          (i.name || "").toLowerCase().includes(this.state.search.toLowerCase()) ||
          (i.iNumber || "").toLowerCase().includes(this.state.search.toLowerCase())
        );
      })
      .sort((a, b) => (a.dateRaw < b.dateRaw ? 1 : -1));

    const today = moment();
    const categorize = (i) => {
      if (i.isCreditNote) return "credit";
      if (i.isQuote) return "quote";
      if (i.paid) return "paid";
      const daysLate = i.dueRaw ? today.diff(moment(i.dueRaw), "days") : 0;
      return daysLate > 0 ? "overdue" : "warn";
    };
    const GROUP_META = {
      overdue: { label: "Overdue", cls: "overdue" },
      warn: { label: "Due soon", cls: "warn" },
      paid: { label: "Paid", cls: "paid" },
      quote: { label: "Quotes", cls: "quote" },
      credit: { label: "Credit notes", cls: "credit" },
    };
    const groups = { overdue: [], warn: [], paid: [], quote: [], credit: [] };
    filtered.forEach((i) => groups[categorize(i)].push(i));
    const groupOrder = ["overdue", "warn", "paid", "quote", "credit"];

    const initials = (nm) =>
      (nm || "?")
        .split(" ")
        .filter(Boolean)
        .slice(0, 2)
        .map((w) => w[0])
        .join("")
        .toUpperCase();
    const avColor = (nm) => {
      let h = 0;
      for (let c = 0; c < (nm || "").length; c++) h = (h * 31 + nm.charCodeAt(c)) % 6;
      return h;
    };

    const invoicedTotal = paidTotal + unTotal;
    const paidPct = invoicedTotal > 0 ? Math.round((paidTotal / invoicedTotal) * 100) : 0;
    const DONUT_CIRC = 263.89;
    const donutOffset = DONUT_CIRC * (1 - paidPct / 100);

    const openInvoice = (id) => {
      this.props.getInvoice(id, (error) => {
        if (!error) this.updateshowAdd(true);
      });
      this.props.selectInvoice(id);
    };

    const periodLabel = this.props.global && this.props.global.dateFrom
      ? this.props.global.dateFrom.format("MMMM YYYY")
      : moment().format("MMMM YYYY");

    return (
      <div className="content-wrapper p-2">
        <SpinnerView showSpinner={this.props.invoices.loading} />

        {this.state.showAdd && (
          <div className="invoice-view-container">
            <Invoice
              showAdd={this.state.showAdd}
              updateshowAdd={this.updateshowAdd}
            />
          </div>
        )}

        {/* Hero band */}
        {!this.state.showAdd && (
          <div className="gl-hero">
            <div className="gl-hero-row">
              <div>
                <div className="gl-hero-title">Invoices</div>
                <div className="gl-hero-sub">
                  {periodLabel} · {all} issued · {un} outstanding
                </div>
              </div>
              <div className="gl-hero-actions">
                <Link className="gl-hero-btn" to="/recurring?type=invoices">
                  <i className="fas fa-sync-alt"></i> Recurring
                </Link>
                <DownloadLink
                  label={<><i className="fas fa-arrow-down"></i> Export</>}
                  className="gl-hero-btn"
                  style={{ textDecoration: "none" }}
                  filename={"sage_import.csv"}
                  exportFile={() => {
                    return Alert.fire({
                      title: "Process the current period unpaid invoices as paid. Do you want to continue?",
                      showDenyButton: true,
                      confirmButtonColor: colors.primary,
                      cancelButtonColor: colors.action,
                      showCancelButton: false,
                      confirmButtonText: "Continue",
                      denyButtonText: `Cancel`,
                    }).then((result1) => {
                      if (result1.isConfirmed) {
                        return Alert.fire({
                          title: "Do you want to mark all invoices as resolved to sage?",
                          showDenyButton: true,
                          confirmButtonColor: colors.primary,
                          cancelButtonColor: colors.action,
                          showCancelButton: false,
                          confirmButtonText: "Resolve all",
                          denyButtonText: `Just download`,
                        }).then((result) => {
                          let url = urls.getInvoices(this.props.selectedCompanyId) + "/export";
                          if (result.isConfirmed) {
                            url = urls.getInvoices(this.props.selectedCompanyId) + "/process";
                          }
                          if (this.props.global) {
                            url = url + "?from=" + this.props.global.dateFrom.format("YYYY-MM-DD");
                            url = url + "&to=" + this.props.global.dateTo.format("YYYY-MM-DD");
                            url = url + "&type=" + this.props.global.dateIndex;
                            return Promise.resolve(
                              this.getDataFromURL(url, this.props.authUser, result.isConfirmed)
                            );
                          }
                        });
                      } else {
                        return "canceled";
                      }
                    });
                  }}
                />
                <button
                  className="gl-hero-btn solid"
                  onClick={() => {
                    this.props.dispatchClearInvoice();
                    this.updateshowAdd(true);
                  }}
                >
                  <i className="fas fa-plus"></i> New invoice
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Summary band */}
        {!this.state.showAdd && (
          <div className="gl-summary">
            <div className="gl-sum-main">
              <div className="gl-sm-eyebrow">Total invoiced · {periodLabel}</div>
              <div className="gl-sm-amount-row">
                <div>
                  <span className="gl-sm-cur">R </span>
                  <span className="gl-sm-num">{format(invoicedTotal)}</span>
                </div>
              </div>
              <div className="gl-sm-legend">
                <div className="gl-sm-leg-item">
                  <div className="gl-sm-leg-dot" style={{ background: "#fff" }}></div>
                  <div>
                    <div className="gl-sm-leg-lbl">Paid</div>
                    <div className="gl-sm-leg-val">R {format(paidTotal)}</div>
                  </div>
                </div>
                <div className="gl-sm-leg-item">
                  <div className="gl-sm-leg-dot" style={{ background: "rgba(255,255,255,0.45)" }}></div>
                  <div>
                    <div className="gl-sm-leg-lbl">Outstanding</div>
                    <div className="gl-sm-leg-val">R {format(unTotal)}</div>
                  </div>
                </div>
                <div className="gl-sm-leg-item">
                  <div className="gl-sm-leg-dot" style={{ background: "rgba(255,255,255,0.22)" }}></div>
                  <div>
                    <div className="gl-sm-leg-lbl">Quotes</div>
                    <div className="gl-sm-leg-val">R {format(quoteTotal)}</div>
                  </div>
                </div>
                {credit > 0 && (
                  <div className="gl-sm-leg-item">
                    <div className="gl-sm-leg-dot" style={{ background: "#F0B429" }}></div>
                    <div>
                      <div className="gl-sm-leg-lbl">Credited</div>
                      <div className="gl-sm-leg-val">-R {format(creditTotal)}</div>
                    </div>
                  </div>
                )}
              </div>
              <svg className="gl-sm-donut" width="104" height="104" viewBox="0 0 110 110">
                <circle cx="55" cy="55" r="42" fill="none" stroke="rgba(255,255,255,0.18)" strokeWidth="10" />
                <circle
                  cx="55" cy="55" r="42" fill="none" stroke="#fff" strokeWidth="10"
                  strokeDasharray={DONUT_CIRC} strokeDashoffset={donutOffset}
                  strokeLinecap="round" transform="rotate(-90 55 55)"
                />
                <text x="55" y="58" textAnchor="middle" fontFamily="GothamRounded, sans-serif" fontWeight="800" fontSize="22" fill="#fff" dominantBaseline="middle">{paidPct}%</text>
              </svg>
            </div>

            <div className="gl-sum-side">
              <div className="gl-ss-eyebrow">Outstanding</div>
              <div className="gl-ss-amount">R {format(unTotal)}</div>
              <div className="gl-ss-meta">{un} invoice{un === 1 ? "" : "s"} unpaid</div>
              {un > 0 ? (
                <span className="gl-ss-pill danger"><i className="fas fa-circle" style={{ fontSize: 5 }}></i> Needs attention</span>
              ) : (
                <span className="gl-ss-pill ok"><i className="fas fa-circle" style={{ fontSize: 5 }}></i> All settled</span>
              )}
            </div>

            <div className="gl-sum-side">
              <div className="gl-ss-eyebrow">Quotes</div>
              <div className="gl-ss-amount">R {format(quoteTotal)}</div>
              <div className="gl-ss-meta">{quote} open quote{quote === 1 ? "" : "s"}</div>
              <span className="gl-ss-pill warn"><i className="fas fa-file-alt" style={{ fontSize: 8 }}></i> Pending</span>
            </div>
          </div>
        )}

        {/* Filter bar */}
        {!this.state.showAdd && (
          <div className="gl-filter">
            <div className="gl-seg">
              <button className={`gl-seg-btn ${this.state.rankType === "all" ? "active" : ""}`} onClick={() => this.setRank("all")}>All <span className="cnt">{all}</span></button>
              <button className={`gl-seg-btn ${this.state.rankType === "unpaid" ? "active" : ""}`} onClick={() => this.setRank("unpaid")}>Outstanding <span className="cnt">{un}</span></button>
              <button className={`gl-seg-btn ${this.state.rankType === "paid" ? "active" : ""}`} onClick={() => this.setRank("paid")}>Paid <span className="cnt">{paid}</span></button>
              <button className={`gl-seg-btn ${this.state.rankType === "quote" ? "active" : ""}`} onClick={() => this.setRank("quote")}>Quotes <span className="cnt">{quote}</span></button>
              {credit > 0 && (
                <button className={`gl-seg-btn ${this.state.rankType === "credit" ? "active" : ""}`} onClick={() => this.setRank("credit")}>Credit notes <span className="cnt">{credit}</span></button>
              )}
            </div>
            <div className="gl-search">
              <i className="fas fa-magnifying-glass"></i>
              <input
                placeholder="Filter this list…"
                value={this.state.search}
                onChange={(e) => this.handleSearch(e.target.value)}
              />
            </div>
            <div style={{ marginLeft: "auto" }}>
              <DateFilter action={this.props.dispatchGetInvoices} />
            </div>
          </div>
        )}

        {/* Status-grouped frosted list */}
        {!this.state.showAdd && (
          <div className="gl-list">
            <div className="gl-list-head">
              <div></div>
              <div>Client</div>
              <div>Invoice #</div>
              <div>Issued · Due</div>
              <div>Amount</div>
              <div>Status</div>
              <div></div>
            </div>

            {filtered.length === 0 && (
              <div className="gl-empty">No invoices match this view.</div>
            )}

            {groupOrder.map((gk) => {
              const items = groups[gk];
              if (!items || items.length === 0) return null;
              const gsum = items.reduce((s, it) => s + (it.totalA || 0), 0);
              return (
                <React.Fragment key={gk}>
                  <div className="gl-group-head">
                    <span className="lbl">{GROUP_META[gk].label}</span>
                    <span className="count">{items.length}</span>
                    <span className="sum">R {format(gsum)}</span>
                  </div>
                  {items.map((it) => {
                    const isSel = this.state.selected.indexOf(it.id) !== -1;
                    const days = it.dueRaw ? today.diff(moment(it.dueRaw), "days") : 0;
                    let statusPill;
                    if (it.queuedError)
                      statusPill = (<span className="gl-pill error"><i className="fas fa-circle" style={{ fontSize: 6 }}></i> Error</span>);
                    else if (it.queued)
                      statusPill = (<span className="gl-pill sending"><i className="fas fa-circle" style={{ fontSize: 6 }}></i> Sending</span>);
                    else if (it.isCreditNote)
                      statusPill = <span className="gl-pill credit">Credit</span>;
                    else if (it.isQuote)
                      statusPill = <span className="gl-pill quote">Quote</span>;
                    else if (it.paid)
                      statusPill = (<span className="gl-pill paid"><i className="fas fa-check" style={{ fontSize: 8 }}></i> Paid</span>);
                    else
                      statusPill = days > 0
                        ? (<span className="gl-pill overdue"><i className="fas fa-circle" style={{ fontSize: 6 }}></i> {days}d late</span>)
                        : (<span className="gl-pill warn"><i className="fas fa-circle" style={{ fontSize: 6 }}></i> {Math.abs(days)}d left</span>);

                    let dueLine = null;
                    if (it.isCreditNote) dueLine = <span>{it.creditOfNumber ? "Credit of " + it.creditOfNumber : "Credit note"}</span>;
                    else if (it.isQuote) dueLine = <span>Quote</span>;
                    else if (it.paid) dueLine = <span className="done">{it.sentDate ? "Sent " + it.sentDate : "Paid"}</span>;
                    else if (it.dueRaw)
                      dueLine = days > 0
                        ? <span className="late">Due {it.dueDate} · {days}d late</span>
                        : <span className="soon">Due {it.dueDate} · {Math.abs(days)}d left</span>;

                    return (
                      <div
                        key={it.id}
                        className={`gl-row ${GROUP_META[gk].cls}`}
                        onClick={() => openInvoice(it.id)}
                      >
                        <div className="gl-check" onClick={(e) => e.stopPropagation()}>
                          <input type="checkbox" checked={isSel} onChange={(e) => this.handleClick(e, it.id)} />
                        </div>
                        <div className="gl-client">
                          <div className={`gl-av gl-av-${avColor(it.name)}`}>{initials(it.name)}</div>
                          <div style={{ minWidth: 0 }}>
                            <div className="name">{it.name || "—"}</div>
                            {it.email ? <div className="sub">{it.email}</div> : null}
                          </div>
                        </div>
                        <div className="gl-num">#{it.iNumber}</div>
                        <div className="gl-date">{it.invoiceDate}<br />{dueLine}</div>
                        <div className={`gl-amount ${it.isCreditNote ? "credit" : (it.paid && !it.isQuote ? "paid" : "")}`}>{it.total}</div>
                        <div>{statusPill}</div>
                        <div className="gl-actions" onClick={(e) => e.stopPropagation()}>
                          <DownloadLink
                            label={<i className="fas fa-download"></i>}
                            className="gl-icon-btn"
                            style={{ textDecoration: "none" }}
                            filename={documentFilename({ invoiceNumber: it.iNumber, invoiceDate: it.dateRaw }, it.name)}
                            exportFile={() =>
                              Promise.resolve(
                                this.getDataFromURL(
                                  urls.getInvoices(this.props.selectedCompanyId) + "/" + it.id + "/download",
                                  this.props.authUser
                                )
                              )
                            }
                          />
                          <button type="button" className="gl-icon-btn" onClick={() => openInvoice(it.id)}>
                            <i className="fas fa-arrow-right"></i>
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </React.Fragment>
              );
            })}

            {/* Selection action bar */}
            <div className="gl-selbar">
              <button type="button" className="gl-selbar-btn" onClick={() => this.handleSelectAll(true)}>
                Select unpaid &amp; unsent
              </button>
              <button type="button" className="gl-selbar-btn" onClick={() => this.handleSelectAll()}>
                Select all unpaid
              </button>
              {this.state.selected.length > 0 && (
                <button type="button" className="gl-selbar-btn" onClick={() => this.setState({ selected: [] })}>
                  Clear {this.state.selected.length} selected
                </button>
              )}
              {this.state.selected.length > 0 && (
                <button
                  type="button"
                  className="gl-selbar-btn danger"
                  onClick={() => {
                    let t = this;
                    Alert.fire({
                      title: "Are you sure you want to send the selected invoices?",
                      showDenyButton: true,
                      showCancelButton: false,
                      confirmButtonText: "Yes",
                      denyButtonText: `No`,
                    }).then((result) => {
                      if (result.isConfirmed) {
                        function doneSent(response) {
                          if (response.message == "Enqueued") {
                            Alert.fire(
                              "Your invoices was queued to be sent, please refresh your invoices after a few minutes"
                            );
                            t.setState({ selected: [] });
                          } else {
                            Alert.fire(
                              "There has been an error with queueing, please try again later or contact support if this happens again."
                            );
                          }
                        }
                        this.props.sendBulkInvoices(this.state.selected, doneSent);
                      } else if (result.isDenied) {
                      }
                    });
                  }}
                >
                  <i className="fas fa-paper-plane"></i> Send {this.state.selected.length} selected
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}
/*
    descriptions:[{
        name:"name",
        "price":100
    }],
    */
export default HomeView;
